import styles from './SplashScreen.module.css';

/**
 * Full-screen loader shown while a board is authenticated, from the
 * "Whiteboard" design artboard: a badge, a dot-grid card on which three
 * collaborators work in turn (a coral pen stroke, a blue circle, a green
 * sticky note), then the wordmark with a pulsing ellipsis. `exiting` plays
 * the fade-out; the parent unmounts it once that finishes. Same overlay and
 * exit as milepad's and milegrid's splash so the apps feel the same.
 */

const CursorGlyph = ({ fill }) => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill={fill} aria-hidden="true">
    <path d="M4 3l16 8-7 2-2 7z" />
  </svg>
);

const SplashScreen = ({ className = '', exiting = false }) => (
  <div
    className={[styles.overlay, exiting && styles.exiting, className].filter(Boolean).join(' ')}
    role="status"
    aria-busy="true"
    aria-live="polite"
    aria-label="Loading board"
  >
    <div className={styles.stack}>
      <div className={styles.badge} aria-hidden="true">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
          <path d="M4 20 15 9l3 3L7 23z" />
          <path d="M14 10l2-4 4 4-2 4z" />
        </svg>
      </div>

      <div className={styles.canvas} aria-hidden="true">
        <div className={styles.grid} />

        {/* Coral collaborator draws a freehand stroke first. */}
        <svg className={styles.layer} width="260" height="170">
          <path className={styles.stroke} d="M150,70 C160,30 178,95 190,55 C198,28 214,58 226,38" />
        </svg>
        <div className={styles.pen}>
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
            <path d="M4 20l1-4L16 5l3 3L8 19l-4 1z" />
          </svg>
        </div>

        {/* Blue collaborator places a circle. */}
        <svg className={styles.layer} width="260" height="170">
          <circle className={styles.circle} cx="58" cy="52" r="28" />
        </svg>
        <div className={`${styles.cursor} ${styles.cursorBlue}`}>
          <CursorGlyph fill="#5b8dd6" />
        </div>

        {/* Green collaborator drops a sticky note last. */}
        <div className={styles.note} />
        <div className={`${styles.cursor} ${styles.cursorGreen}`}>
          <CursorGlyph fill="#3aa76d" />
        </div>
      </div>

      <div className={styles.wordmark}>
        <div className={styles.title}>Whiteboard</div>
        <div className={styles.dots}>
          <span className={styles.dot} style={{ animationDelay: '0s' }} />
          <span className={styles.dot} style={{ animationDelay: '.15s' }} />
          <span className={styles.dot} style={{ animationDelay: '.3s' }} />
        </div>
      </div>
    </div>
  </div>
);

export default SplashScreen;
